import { render } from "./IconAccessibility.vue?vue&type=template&id=e88be760"
import script from "./IconAccessibility.vue?vue&type=script&lang=js"
export * from "./IconAccessibility.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__